import React, { createContext, useContext, useState, useMemo } from 'react';

interface ExpensesYearContextValue {
  year: number;
  setYear: (y: number) => void;
  availableYears: number[];
}

const ExpensesYearContext = createContext<ExpensesYearContextValue | undefined>(undefined);

interface ProviderProps {
  children: React.ReactNode;
  yearsBack?: number; // default 5
}

export const ExpensesYearProvider: React.FC<ProviderProps> = ({ children, yearsBack = 5 }) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState<number>(currentYear);
  const availableYears = useMemo(() => Array.from({ length: yearsBack }, (_, i) => currentYear - i), [currentYear, yearsBack]);
  return (
    <ExpensesYearContext.Provider value={{ year, setYear, availableYears }}>
      {children}
    </ExpensesYearContext.Provider>
  );
};

export const useExpensesYear = () => {
  const ctx = useContext(ExpensesYearContext);
  if (!ctx) {
    // Allow components to still function standalone if provider missing
    const fallbackYear = new Date().getFullYear();
    return {
      year: fallbackYear,
      setYear: () => { /* no-op outside provider */ },
      availableYears: [fallbackYear]
    } as ExpensesYearContextValue;
  }
  return ctx;
};

export default ExpensesYearContext;